<template>
<div class="section">
  <div class="columns is-centered">
    <div class="column is-6">
      <div class="modal-card">
        <div class="modal-card-head">
          <b-loading
            :is-full-page="true"
            :active.sync="isLoading"
            :can-cancel="false"
          ></b-loading>
        </div>
        <div class="modal-card-body">
          <div class="section">
            <div class="container">
              <h1 class="title">{{ $t('Recibir llamada') }}</h1>
              <p>
                {{ $t('Elige como quieres que contactemos contigo') }}
              </p>
              <div class="field" style="margin-top: 40px;">
                <b-radio v-model="contactMethod" native-value="email">
                  {{ $t('Enviar un email') }}
                </b-radio>
              </div>
              <div class="field">
                <b-radio v-model="contactMethod" native-value="videoconference">
                  {{ $t('Organizar una videoconferencia') }}
                </b-radio>
              </div>
              <div class="field">
                <b-radio v-model="contactMethod" native-value="meeting">
                  {{ $t('Organizar un call') }}
                </b-radio>
              </div>
              <div class="field">
                <b-radio v-model="contactMethod" native-value="call">
                  {{ $t('Recibir llamada') }}
                </b-radio>
              </div>
              <p style="text-align: center; margin-top: 40px;">
                <b-button
                  @click="updateContactMethod"
                  size="is-large"
                  type="is-primary"
                  >{{ $t('Enviar') }}</b-button
                >
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Fetcher from '@/mixins/fetcher.js'

export default {
  mixins: [Fetcher],
  components: {},
  data() {
    return {
      contactMethod: null
    }
  },
  mounted() {
    this.contactMethod = this.neofintechData.contactMethod
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  methods: {
    ...mapActions('onBoard', ['putUpdateOnboardRequest']),
    updateContactMethod: function() {
      let self = this
      self.request(() =>
        self.putUpdateOnboardRequest({
          data: { contact_method: self.contactMethod },
          requestId: self.neofintechData.requestId
        })
      )
    }
  }
}
</script>
